import React, { ReactNode } from "react";
import Divider from "@mui/material/Divider";

interface Props {
  children: ReactNode;
  DividerComponent?: React.ComponentType;
}
export default ({ children, DividerComponent }: Props) => {
  const childrenArray = React.Children.toArray(children);
  const childrenWithDividers: ReactNode[] = [];

  childrenArray.forEach((child, index) => {
    if (index !== 0) {
      childrenWithDividers.push(
        DividerComponent ? (
          <DividerComponent key={`divider-${index}`} />
        ) : (
          <Divider key={`divider-${index}`} />
        ),
      );
    }
    childrenWithDividers.push(child);
  });

  return <>{childrenWithDividers}</>;
};
